import Toolbar from "./brochure/Toolbar";
import CoverPage from "./brochure/CoverPage";
import TOCPage from "./brochure/TOCPage";
import AboutPage from "./brochure/AboutPage";
import VisionPage from "./brochure/VisionPage";
import BenefitsPage from "./brochure/BenefitsPage";
import SectorsPage from "./brochure/SectorsPage";
import ServicesPage from "./brochure/ServicesPage";
import ProcessPage from "./brochure/ProcessPage";
import TestimonialPage from "./brochure/TestimonialPage";
import ContactPage from "./brochure/ContactPage";
import BackCoverPage from "./brochure/BackCoverPage";

export default function Brochure() {
  const handlePrint = () => window.print();

  return (
    <>
      <Toolbar onPrint={handlePrint} />
      <div className="brochure" data-testid="brochure-root">
        <CoverPage />
        <TOCPage />
        <AboutPage />
        <VisionPage />
        <BenefitsPage />
        <SectorsPage />
        <ServicesPage />
        <ProcessPage />
        <TestimonialPage />
        <ContactPage />
        <BackCoverPage />
      </div>
    </>
  );
}
